import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {useCancelBookingMutation, useGetOrderQuery} from 'services/orders';
import Button from 'components/ui/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {enqueueSnackbar} from 'notistack';

const CancelBooking = ({currentBooking}: any) => {
    const { orderId = '' } = useParams();
    const { data: orderData, isLoading } = useGetOrderQuery(orderId);
    const [cancelBooking] = useCancelBookingMutation();
    console.log(currentBooking);

    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const handleCancelBooking = async () => {
        if (!currentBooking) {
            enqueueSnackbar('There was an error on the booking id, please try again', { variant: 'error', autoHideDuration: 1000 });
            return;
        }

        try {
            await cancelBooking(currentBooking).unwrap();
            enqueueSnackbar('Booking successfully canceled', { variant: 'success', autoHideDuration: 1000 });
            handleClose();
        } catch (error) {
            console.error('Failed to cancel booking:', error);
            enqueueSnackbar('Failed to cancel booking. Please try again.', { variant: 'error', autoHideDuration: 1000 });
        }
    };

    if (isLoading) return <div>Loading...</div>;

    return (
        <>
            <Button onClick={handleOpen} cc-color="red">Cancel Booking</Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Cancel Booking</DialogTitle>
                <DialogContent>
                    <p>Are you sure you want to cancel this booking?</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleCancelBooking} cc-color="red" disabled={!currentBooking}>
                        Confirm Cancellation
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CancelBooking;
